import { render } from "./WCMobileContextMenu.vue?vue&type=template&id=7332667b&scoped=true"
import script from "./WCMobileContextMenu.vue?vue&type=script&lang=js"
export * from "./WCMobileContextMenu.vue?vue&type=script&lang=js"

import "./WCMobileContextMenu.vue?vue&type=style&index=0&id=7332667b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7332667b"]])

export default __exports__